import { render, staticRenderFns } from "./CreateSlag.vue?vue&type=template&id=06b06955&scoped=true"
import script from "./CreateSlag.vue?vue&type=script&lang=js"
export * from "./CreateSlag.vue?vue&type=script&lang=js"
import style0 from "./CreateSlag.vue?vue&type=style&index=0&id=06b06955&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b06955",
  null
  
)

export default component.exports